module.exports = __webpack_public_path__ + "static/content_5_3_eg-81e173ae75daa2c284edb6c3bc811359.png";